import { reportMetricDefinitions } from '../reporting/reportExplorer/catalog';
import type { ReportResponse } from '../reporting/reportExplorer/model';
import { ReportMetric } from '../reporting/reportExplorer/reportEnums';

export function reportDashboardMetricValues(row: ReportResponse['total']) {
  const value = (metric: ReportMetric) => {
    const result = row?.[reportMetricDefinitions[metric].field];
    return typeof result === 'number' ? result : undefined;
  };
  return {
    adImpressions: value(ReportMetric.AdImpressionsLi),
    revenue: value(ReportMetric.RevenueLi),
    rpm: value(ReportMetric.RpmLi),
    adClicks: value(ReportMetric.AdClicks),
  };
}
